import React from 'react';
import ExpensesByTypePage from './ExpensesByTypePage';
import { ExpenseType } from '../../types/homeExpenses';

const PersonalExpensesPage: React.FC = () => (
  <ExpensesByTypePage expenseType={ExpenseType.Personal} title="Despesas pessoais" />
);

export default PersonalExpensesPage;
